import React, {useEffect, useState} from 'react';
import axios from "axios";
import {instance} from "../Auth";
import {setUserId} from "../Store/Store";

interface PartnerStatusProps {
    online: boolean;
}
//TODO - при оключении от сокета нужно оповещать, иначе непонятно когда покинули чат.

const UserStatus: React.FC<PartnerStatusProps> = ({online}) => {
    const [lastOnline, setLastOnline] = useState('-')

    useEffect(() => {
        getLastOnline().then(setLastOnline);
    }, [online]);

    return (
        <span style={{
            color: '#8e8e93',
            position: 'relative',
            top: -1,
            left: 10,
            fontSize: 11
        }}>{online ? "В сети" : lastOnline}</span>
    )
};
const getLastOnline = async () => {
    try {
        const response = await instance.get('/last-online');
        return response.data;
    } catch (error) {
        console.error('Ошибка при получении времени последнего онлайна:', error);
        return "н/о";
    }
};
export default UserStatus;
